<template>
    <div>
        <loading-spinner :loading="loading"></loading-spinner>
        <nav-bar></nav-bar>
        <router-view :key="$route.path"></router-view>

        <account-modal v-if="model.showAccountModal" @noEvent="model.showAccountModal = false"></account-modal>
        <payment-modal v-if="model.showSubscriptionModal" @noEvent="model.showSubscriptionModal = false"></payment-modal>
    </div>
</template>

<script>
    import UserService from "./services/UserService";
    import NavBar from "./layout/NavBar.vue";
    import LoadingSpinner from "./components/LoadingSpinner.vue";
    import AccountModal from "./components/AccountModal.vue";
    import PaymentModal from "./components/PaymentModal.vue";
    import PublicHttpService from "./services/PublicHttpService";

    export default {
        name: 'App',
        components: {PaymentModal, AccountModal, LoadingSpinner, NavBar},
        computed: {
            loading() {
                return this.model.loading
            }
        },
        data() {
            return {
                model: webase.model
            }
        },
        created() {
            console.log('App created')
            console.log(window.location.hostname)

            // if(window.location.hostname !== 'www.webase.com') {
            //     let host = window.location.hostname
            //
            //     if (process.env.NODE_ENV === 'development' || window.location.href.indexOf('localhost') > -1) {
            //         host = 'no-code-whitelabel-lrhv9kf93uijvqwj.netlify.app'
            //     }
            //
            //     let service = new PublicHttpService()
            //     service.getWhitelabelConfig(host).then( (response) => {
            //
            //         if(response.host_domain) {
            //             this.model.siteConfig = response
            //         }
            //     }).catch((error) => {
            //         console.log('Error loading site config.')
            //         console.log(error)
            //     })
            // }
        },
        mounted() {
            console.log('App mounted')
            console.log(this.model)

            if(this.model.auth_token) {
                let service = new UserService()
                service.current().then( (user) => {
                    if(user.role === 'owner' || user.role === 'admin') {
                        service.permissions()
                    }
                })
            }

        }
    }
</script>